import { Box, Button, useTheme } from '@mui/material';
import { memo, useMemo } from 'react';

const VARIANTS = [
    {
        label: 'vertical',
        text: 'Analítica',
        tipo: ['equipo', 'partido'],
    },
    {
        label: 'split',
        text: 'Versus',
        tipo: ['partido'],
    },
    {
        label: 'horizontal',
        text: 'Rival',
        tipo: ['partido', 'equipo'],
    },
];

const VariantButton = memo(({ variant, currentVariant, onClick }) => {
    const isActive = variant?.label === currentVariant;
    const theme = useTheme();
    const buttonStyle = useMemo(
        () => ({
            color: isActive ? theme.palette.text.primary : theme.palette.border.darkerLight,
            padding: 0,
            minHeight: '24px',
            height: '24px',
            border: '1px solid',
            borderColor: isActive ? theme.palette.text.primary : theme.palette.border.darkerLight,
            borderRadius: 0.5,
            fontSize: 12,
        }),
        [isActive, theme]
    );

    return (
        <Button onClick={onClick} variant="outlined" sx={buttonStyle}>
            {variant.text}
        </Button>
    );
});

VariantButton.displayName = 'VariantButton';

function LineupVariantSelector({ variant, setVariant, tipo, isMobile }) {
    const variantes = useMemo(() => VARIANTS.filter((v) => v.tipo.includes(tipo)), [tipo]);

    return (
        <Box display="flex" gap={0.5}>
            {variantes
                ?.filter((v) => !isMobile || v.label !== 'horizontal')
                .map((v) => (
                    <VariantButton
                        key={v.label}
                        variant={v}
                        currentVariant={variant}
                        onClick={() => setVariant(v.label)}
                    />
                ))}
        </Box>
    );
}

LineupVariantSelector.displayName = 'LineupVariantSelector';

export default memo(LineupVariantSelector);
